import { createFileRoute } from '@tanstack/react-router'

import { feedbackFormsSearchSchema } from '@/pages/feedback-forms/feedback-forms-search'

export const Route = createFileRoute('/_layout/feedback-forms/')({
  validateSearch: feedbackFormsSearchSchema,
})
